import anzaL6_1 from "./1.png";
import anzaL6_2 from "./2.png";
import anzaL6_3 from "./3.png";
import anzaL6_4 from "./4.png";

const anzahome6 = [anzaL6_1, anzaL6_2, anzaL6_3, anzaL6_4];

export default anzahome6;
